import styled from "styled-components";
import { sizes } from "styles";

export const UpcomingClassContainer = styled.div<{
  isWidthApplied: boolean;
  isHeroSection: boolean;
  heroSectionMeta?: {
    backgroundColor: string;
    text: string;
  };
}>`
  width: ${({ isWidthApplied }) =>
    isWidthApplied ? `${sizes.kelasLive.upcomingClassCardWidth}` : "auto"};
  flex-shrink: 0;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.white};
  padding: 20px;
  box-shadow: 0px 0px 14px ${({ theme }) => theme.colors.transparent.white10};
  position: relative;

  ${({ isHeroSection, theme, heroSectionMeta }) =>
    isHeroSection &&
    heroSectionMeta &&
    `
      &::before {
        content: "    " url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17' height='22' viewBox='0 0 17 22' fill='none'%3E%3Cpath d='M16.1571 14.0251C16.6222 9.62065 13.7733 5.63288 9.79386 5.11813C5.81444 4.60338 2.21147 7.75658 1.7464 12.161C1.28132 16.5654 4.13025 20.5532 8.10966 21.0679C12.0891 21.5827 15.692 18.4295 16.1571 14.0251Z' fill='%23BFA400'/%3E%3Cpath d='M9.5937 19.1062C13.5725 18.5854 16.4379 14.7936 15.9938 10.637C15.5497 6.48031 11.9642 3.53282 7.98546 4.05356C4.00668 4.57431 1.14127 8.3661 1.58537 12.5228C2.02947 16.6794 5.61492 19.6269 9.5937 19.1062Z' fill='%23FBDD12'/%3E%3Cpath d='M12.2557 11.0755C13.9467 8.70185 13.579 5.26043 11.4345 3.38883C9.28991 1.51723 6.18057 1.92418 4.48956 4.29779C2.79856 6.67139 3.16625 10.1128 5.31081 11.9844C7.45538 13.856 10.5647 13.4491 12.2557 11.0755Z' fill='%23C1A80A'/%3E%3Cpath d='M8.79005 11.5796C11.5022 11.2246 13.4515 8.60351 13.144 5.72522C12.8365 2.84693 10.3886 0.801371 7.67642 1.15634C4.96426 1.51131 3.01492 4.13239 3.32244 7.01068C3.62996 9.88897 6.07789 11.9345 8.79005 11.5796Z' fill='%23FFE831'/%3E%3C/svg%3E");
        position: absolute;
        top: 0;
        left: 50%; /* Center horizontally */
        transform: translateX(-50%);
        background-color: ${heroSectionMeta.backgroundColor};
        width: 100%;
        padding-top: 8px;
        padding-bottom: 7px;
        border-top-right-radius: 8px;
        border-top-left-radius: 8px;
        white-space:pre
      };

      &::after {
        content: "${heroSectionMeta.text}";
        position: absolute;
        top: 0;
        right: 40%;
        padding-top: 14px;
        color: ${theme.colors.brand["800"]};
        font-size: 18px;
        font-weight: bold;
        text-align: center;
      }
    `}
`;

export const UpcomingClassDetailsContainer = styled.div<{
  isHeroSection: boolean;
}>`
  display: flex;
  gap: 16px;
  padding: ${({ isHeroSection }) => (isHeroSection ? 0 : "0 0 16px 0")};
  position: relative;
  margin-top: ${({ isHeroSection }) => (isHeroSection ? "5%" : "0px")};

  ${({ isHeroSection }) =>
    isHeroSection &&
    `&::before {
    content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17' height='22' viewBox='0 0 17 22' fill='none'%3E%3Cpath d='M16.1571 14.0251C16.6222 9.62065 13.7733 5.63288 9.79386 5.11813C5.81444 4.60338 2.21147 7.75658 1.7464 12.161C1.28132 16.5654 4.13025 20.5532 8.10966 21.0679C12.0891 21.5827 15.692 18.4295 16.1571 14.0251Z' fill='%23BFA400'/%3E%3Cpath d='M9.5937 19.1062C13.5725 18.5854 16.4379 14.7936 15.9938 10.637C15.5497 6.48031 11.9642 3.53282 7.98546 4.05356C4.00668 4.57431 1.14127 8.3661 1.58537 12.5228C2.02947 16.6794 5.61492 19.6269 9.5937 19.1062Z' fill='%23FBDD12'/%3E%3Cpath d='M12.2557 11.0755C13.9467 8.70185 13.579 5.26043 11.4345 3.38883C9.28991 1.51723 6.18057 1.92418 4.48956 4.29779C2.79856 6.67139 3.16625 10.1128 5.31081 11.9844C7.45538 13.856 10.5647 13.4491 12.2557 11.0755Z' fill='%23C1A80A'/%3E%3Cpath d='M8.79005 11.5796C11.5022 11.2246 13.4515 8.60351 13.144 5.72522C12.8365 2.84693 10.3886 0.801371 7.67642 1.15634C4.96426 1.51131 3.01492 4.13239 3.32244 7.01068C3.62996 9.88897 6.07789 11.9345 8.79005 11.5796Z' fill='%23FFE831'/%3E%3C/svg%3E");
    position: absolute;
    top: -48px;
    right: 0;
    padding-top: 12px;
  }`}
`;
export const UpcomingClassDetailsBlock = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const UpcomingClassCardTopicsContainer = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 8px;
  overflow-x: auto;
  white-space: nowrap;

  /* Hide scrollbar */
  scrollbar-width: none; /* For Firefox */
  -ms-overflow-style: none; /* For Internet Explorer and Edge */
  &::-webkit-scrollbar {
    display: none; /* For WebKit-based browsers */
  }
`;

export const UpcomingClassCardImageWrapper = styled.figure`
  margin: 0;
  padding: 0;
  width: 130px;
  height: 130px;
  position: relative;
  flex-shrink: 0;
`;
export const UpcomingClassCardDetailsHeading = styled.h3`
  margin: 8px 0;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  color: ${({ theme }) => theme.colors.black};
  line-height: 1.3;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const UpcomingClassCardDetailsTeacher = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  color: ${({ theme }) => theme.colors.black};
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const UpcomingClassCardInfoItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const UpcomingClassCardInfoItem = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  color: ${({ theme }) => theme.colors.neutral[600]};
  margin: 0;
  &:not(:last-child) {
    &:after {
      content: "•";
      margin: 0 4px;
      font-size: ${({ theme }) => theme.fontSizes["md"]};
      color: ${({ theme }) => theme.colors.neutral[300]};
    }
  }
`;

export const UpcomingClassMoreDetailsContainer = styled.div<{
  isHeroSection: boolean;
}>`
  padding: 20px 0 0 0;
  border-top: ${({ isHeroSection, theme }) =>
    !isHeroSection ? `1px solid ${theme.colors.neutral[200]}` : null};
  display: flex;
  align-items: center;
  justify-content: ${({ isHeroSection }) =>
    isHeroSection ? "center" : "space-between"};
`;

export const UpcomingClassCardTimer = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  color: ${({ theme }) => theme.colors.neutral[600]};
  font-weight: bold;
`;

export const UpcomingClassCardTimerHighlight = styled.span`
  color: ${({ theme }) => theme.colors.brand[500]};
  background: ${({ theme }) => theme.colors.yellow[200]};
  border-radius: 4px;
  padding: 2px 4px;
`;

export const UpcomingClassCardTimerDots = styled.span`
  color: ${({ theme }) => theme.colors.brand[500]};
  margin: 0 4px;
`;

export const UpcomingClassButtonWrapper = styled.div`
  position: relative;
  z-index: 1;
`;

export const SVGContainer = styled.div``;
